/** Copyright © 2024 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';

import type { Auth, CommonResponseWrapper } from 'hems';

import type { AuthTypeAndRoleInfo, AuthTypeAndRoleInfoResponse } from 'hems/auth/account';

export default class AuthService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  getRealtimeApiAuthToken = async (): Promise<{ data: string; status: string | number }> =>
    await this.get(apiWrapper.daqApi('/v1/auth'));

  exchangeEntraIdTokenToAccessToken = async (entraIdToken: string): Promise<Auth.TokenInfoResponse> => {
    const { data } = await this.post<CommonResponseWrapper<Auth.TokenInfoResponse>>(
      apiWrapper.authenticationApi('/exchange-tokens'),
      {},
      {
        headers: {
          Authorization: `Bearer ${entraIdToken}`,
        },
      }
    );

    return data;
  };

  getAuthTypeAndRole = async (userId: string, accessToken: string): Promise<AuthTypeAndRoleInfo> => {
    const { data } = await this.get<AuthTypeAndRoleInfoResponse>(
      apiWrapper.managerApiV1(`/users/${userId}`),
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return data;
  };
}
